import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
* {
-webkit-box-sizing: border-box;
   -moz-box-sizing: border-box;
        box-sizing: border-box;
}`;

export default GlobalStyle;
